import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function httpPostPasswordRecovery(data) {
  const url = `${API_BASE_URL}/auth/password/reset-request`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function httpPostPasswordReset(data) {
  const url = `${API_BASE_URL}/auth/password/reset`;
  return request({
    url,
    method: "post",
    data,
  });
}
